import { render, staticRenderFns } from "./user_login.vue?vue&type=template&id=48f35317&scoped=true&"
import script from "./user_login.vue?vue&type=script&lang=js&"
export * from "./user_login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f35317",
  null
  
)

export default component.exports